import { TpeAlert } from "@shared/entities/tpe_alerts_types.entity";

export enum UserFunctionalityID {
  ALLOWED_CHANGE_PARAMS = "ALLOWED_CHANGE_PARAMS",
  ALLOWED_CHANGE_VEHICLES = "ALLOWED_CHANGE_VEHICLES",
  ALLOWED_CHANGE_DRIVERS = "ALLOWED_CHANGE_DRIVERS",
  ALLOWED_CHANGE_LOCATIONS = "ALLOWED_CHANGE_LOCATIONS",
  ALLOWED_BLOCK_VEHICLE = "ALLOWED_BLOCK_VEHICLE"
}

export interface ValidateFields {
  email: boolean;
}

export interface TpeAlertWithFunctionality extends TpeAlert {
  isAFunctionality?: boolean;
  idFunctionality?: UserFunctionalityID;
}
